import Alpine from "alpinejs";

Alpine.data("carouselButtons", (id) => {
  return {
    id: id,
    firstLastVisibility: {
      first: false,
      last: false,
    },
    get carousel() {
      return document.querySelector(`[x-data="carousel('${this.id}')"]`);
    },
    get canGoPrevious() {
      return !this.firstLastVisibility.first;
    },
    get canGoNext() {
      return !this.firstLastVisibility.last;
    },
    get atStart() {
      return this.firstLastVisibility.first;
    },
    get atEnd() {
      return this.firstLastVisibility.last;
    },
    init() {
      window.addEventListener(`carousel:${this.id}:item-enter`, (event) => {
        const index = event.detail.index;
        if (index === 0) {
          this.firstLastVisibility.first = true;
        }

        if (index === this.carousel.children.length - 1) {
          this.firstLastVisibility.last = true;
        }
      });

      window.addEventListener(`carousel:${this.id}:item-leave`, (event) => {
        const index = event.detail.index;
        if (index === 0) {
          this.firstLastVisibility.first = false;
        }

        if (index === this.carousel.children.length - 1) {
          this.firstLastVisibility.last = false;
        }
      });
    },
  };
});
